
<div :data-component-name="$options.name">
  <b-row>
    <b-col class="col-12 d-flex justify-content-center">
      <img v-lazy="jel_getFichierSrc(content.image)" class="image" :alt="content.titre" />
    </b-col>
    <b-col class="col-12 d-flex justify-content-center">
      <p class="mb-2">
        <span class="titre graphik_bold" v-html="content.titre" />
      </p>
    </b-col>
    <b-col class="col-12 d-flex justify-content-center">
      <template v-if="content.sousTitre">
        <p v-html="content.sousTitre"></p>
      </template>
    </b-col>
    <b-col class="col-12 d-flex justify-content-center">
      <div class="h-50 d-inline-block texte text-center" v-html="content.texte" />
    </b-col>
  </b-row>
</div>
